import React from "react";
import { type State } from "@hookstate/core";
import { useLang } from "~/hooks/useLang";
import { Chip, Grid, Stack, TextField, Typography } from "@mui/material";
import type { ICheckoutEquipment, IWarehouseCheckout } from "../../interface";

interface EquipmentsCheckinProps {
  readonly warehouseCheckout: State<IWarehouseCheckout | null>
  readonly hasSubmitted: boolean
}

type EquipmentCheckinStatus = 'lost' | 'disposed' | 'returnedDamaged' | null

function isNotesRequired(equipment: ICheckoutEquipment): boolean {
  return !!equipment.disposed || !!equipment.lost || !!equipment.returnedDamaged
}

export default function EquipmentsCheckin({ warehouseCheckout, hasSubmitted }: EquipmentsCheckinProps) {
  const { translate } = useLang()
  const handleEquipmentStatusChange = (index: number, status: NonNullable<EquipmentCheckinStatus>) => {
    const equipment = warehouseCheckout['checkoutEquipments'][index]
    const isAlreadySelected = equipment[status].get()

    equipment.lost.set(false)
    equipment.disposed.set(false)
    equipment.returnedDamaged.set(false)

    if (!isAlreadySelected) {
      equipment[status].set(true)
    }
  }

  return (
    <>
      <Typography variant="h6" marginBottom={2}>
        {translate('Equipments')}
      </Typography>
      <Grid container xs={12} spacing={2} marginBottom={2} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
        {warehouseCheckout.get()?.checkoutEquipments.map((equipment, index) => {
          return (
            <Grid key={equipment.id} item container xs={12} spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Equipamento'}
                  disabled={true}
                  value={equipment.equipment?.name}
                />
              </Grid>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Grupo de Equipamento'}
                  disabled={true}
                  value={equipment.equipment?.equipmentGroup?.name}
                />
              </Grid>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Serial Number'}
                  disabled={true}
                  value={equipment.equipment?.serialNumber}
                />
              </Grid>
              <Grid item xs={3} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={translate("Notes")}
                  required={isNotesRequired(equipment)}
                  error={hasSubmitted && isNotesRequired(equipment) && !equipment.notes}
                  // helperText={hasSubmitted && isNotesRequired(equipment) && !equipment.notes ? translate('Notes is required') : undefined}
                  disabled={false}
                  value={equipment.notes ?? ''}
                  onChange={(event) => {
                    warehouseCheckout['checkoutEquipments'][index].notes.set(event.target.value)
                  }}
                  multiline={true}
                  rows={4}
                  sx={{ height: 92 }}
                />
              </Grid>
              <Grid item xs={3}>
                <Stack direction="row" spacing={1}>
                  <Chip
                    label={translate('Disposed')}
                    color={equipment.disposed ? 'success' : 'default'}
                    onClick={() => handleEquipmentStatusChange(index, 'disposed')}
                    sx={{ width: '150px' }}
                  />
                  <Chip
                    label={translate('Lost')}
                    color={equipment.lost ? 'success' : 'default'}
                    onClick={() => handleEquipmentStatusChange(index, 'lost')}
                    sx={{ width: '150px' }}
                  />
                  <Chip
                    label={translate('Returned Damaged')}
                    color={equipment.returnedDamaged ? 'success' : 'default'}
                    onClick={() => handleEquipmentStatusChange(index, 'returnedDamaged')}
                    sx={{ width: '150px' }}
                  />
                </Stack>
              </Grid>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}